export class SourceTimeStampValidation {
    constructor(timeStampValidation, digests) {
        this.digests = digests;
        this.timeStampValidation = timeStampValidation;
        this.digest = undefined;
        this.sameHash = false;
        if (digests) {
            this.digest = digests.find(h => h.hash === timeStampValidation.tokenInfo.hash);
            if (this.digest !== undefined) {
                this.sameHash = this.digest.hash === timeStampValidation.tokenInfo.hash;
            }
        }
    }
}
